import React from "react";

function WhiteStarIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none">
      <path
        fill="#ffffff"
        d="M9.546 1.055c.292-.936 1.616-.936 1.909 0l1.632 5.226a1 1 0 00.955.702h5.364c.96 0 1.368 1.22.603 1.798l-4.407 3.33a1 1 0 00-.351 1.095l1.667 5.336c.29.928-.782 1.682-1.557 1.096l-4.258-3.217a1 1 0 00-1.206 0L5.64 19.638c-.776.586-1.848-.168-1.558-1.096l1.667-5.336a1 1 0 00-.351-1.096L.99 8.78c-.765-.578-.356-1.797.603-1.797h5.364a1 1 0 00.955-.702l1.633-5.226z"
      ></path>
    </svg>
  );
}

export default WhiteStarIcon;